import React, { useState, useEffect } from "react"
import { Layout, Menu, Popover, Select } from 'antd';
import images from '../../themes/appImage'
import { BrowserRouter as Router, Link, useNavigate } from "react-router-dom";
import { Table, Breadcrumb, Modal } from 'antd';
import appconstant from "../../themes/appconstant";
import { Progress } from 'antd';


const { Header, Content, Footer, Sider } = Layout;

const handleChange = (value) => {
    console.log(`selected ${value}`);
};

const InnerCircleReport
    = () => {


        // popover 
        const [open, setOpen] = useState(false);
        const hide = () => {
            setOpen(false);
        };
        const handleOpenChange = (newOpen) => {
            setOpen(newOpen);
        };
        // end popover


        // tab switch

        const [selectedTab, setSelectedTab] = useState(1);
        // const [readMoreSelectedTab, setrReadMoreSelectedTab] = useState(0);

        // 

        const navigate = useNavigate()


        useEffect(() => {
            document.title = 'MentalFit';
        }, [])



        return (

            <div className="body-background">
                <div className="top-header-organi-zations enter-tainment-top">
                    <div className="organi-zations-heading-text">
                        <h1>Inner Circle Report</h1>
                        <p>Sed consectetur imperdiet facilisiulla malesua daeddiet facilisiulla</p>
                    </div>
                </div>

                <div className="gratitude-attitude-new-sec top-bottom-margin-sp">
                    <div className="problem-type-hate">
                        <div className="hate-speech">
                            <div className="problem-type">
                                <p>Report Reason</p>
                                <h6>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore Lore m ipsum dolor sit amLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore Lore m ipsum dolor sit amLorem ipsum dolor sit amet, consectetur adipisci</h6>
                            </div>
                            <div className="post-cont">
                                <Popover
                                    content={
                                        <div className="popup" style={{ width: "200px" }}>
                                            <div className="edit-account">
                                                <p><span><img src={images.crossSquar} alt="crossSquar" /></span>Remove User</p>
                                            </div>
                                            <div className="edit-account freeze-account">
                                                <p><span><img src={images.rightClick} alt="rightClick" /></span>Ignore</p>
                                            </div>

                                        </div>

                                    }
                                    title=""
                                    trigger="click"
                                    placement="bottomLeft"
                                    overlayClassName="update-popup"
                                    open={open}
                                    onOpenChange={handleOpenChange}
                                >

                                    <img src={images.horizontalDots} alt="horizontalDots" />
                                </Popover>

                                {/* <img src={images.horizontalDots} /> */}
                            </div>
                        </div>

                        <div className="annette-black-avatar">
                            <div className="black-avatar">
                                <p> <span><img src={images.maleTable} /> </span> Annette Black</p>
                            </div>

                            <div className="black-avatar-date">
                                <p>March 23, 2013</p>

                            </div>

                        </div>

                    </div>

                </div>

                <div className="slider-section">


                    <div className="wh-assesment inner-padding-space">
                        <div className="scheduled-inner-cricle">

                            <div className="scheduled-activites">
                                <div className="my-inner-cricle">
                                    <div className="inner-backarrow-cricle">
                                        <img src={images.backArrow} alt="backarrow" />
                                    </div>
                                    <div className="inner-heading-cricle">
                                        <h1>My Inner Circle</h1>
                                        <div className="reation">
                                            <div className="avatars my-inner-avatars">
                                                <span><img src={images.firstIcon} alt="firstIcon" /></span>
                                                <span><img src={images.avatarTow} alt="avatarTow" /></span>
                                                <span><img src={images.avatarThree} alt="avatarThree" /></span>
                                                <span><img src={images.avatarFour} alt="avatarfour" /></span>
                                                <span><img src={images.avatarFive} alt="avatarfour" /></span>
                                                <span className="get-more">+3</span>
                                            </div>
                                        </div>

                                    </div>
                                    <div></div>
                                </div>

                                <div className="cricle-feed-tab">
                                    <div className="inner-tab-section">
                                        <div className="cricle-tab ">
                                            <button onClick={() => setSelectedTab(1)} className={selectedTab === 1 ? "active-tab" : ""}>Circle</button>
                                        </div>

                                        <div className="cricle-tab ">
                                            <button onClick={() => setSelectedTab(2)} className={selectedTab === 2 ? "active-tab" : ""}>Feed</button>
                                        </div>
                                    </div>
                                </div>

                                {selectedTab === 1 &&
                                    <div>


                                        <div className="scheduled-circle-activities">
                                            <h1>Scheduled Circle Activities</h1>
                                            <div className="create-act">
                                                <h5>No Activity Yet</h5>
                                                <p>This is a short activity description</p>

                                                <div className="activity-btn">
                                                    <button>Create Activity</button>
                                                </div>

                                            </div>
                                        </div>




                                        <div className="most-active-members">
                                            <div className="active-members-heading">
                                                <h1>Most Active Members</h1>
                                                <img src={images.questions} alt="questions" />
                                            </div>

                                            <div className="mambers-rating">
                                                <div className="list-of-avatar">
                                                    <h2>1st</h2>
                                                    <p>Johnny99</p>

                                                    <div className="range-of-active">
                                                        <div className="active-avatar-iocn">
                                                            <img src={images.avatarJohn} alt="avatarJohn" />
                                                        </div>
                                                        <div className="rang-in-per">
                                                            <p>0<span>%</span></p>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="list-of-avatar">
                                                    <h2>2nd</h2>
                                                    <p>adam.a</p>

                                                    <div className="range-of-active">
                                                        <div className="active-avatar-iocn">
                                                            <img src={images.activeFemail} alt="activeFemail" />
                                                        </div>
                                                        <div className="rang-in-per">
                                                            <p>0<span>%</span></p>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="list-of-avatar">
                                                    <h2>3rd</h2>
                                                    <p>happy.p</p>

                                                    <div className="range-of-active">
                                                        <div className="active-avatar-iocn">
                                                            <img src={images.secondFemail} alt="secondFemail" />
                                                        </div>
                                                        <div className="rang-in-per">
                                                            <p>0<span>%</span></p>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="list-of-avatar">
                                                    <h2>4th</h2>
                                                    <p>Samig</p>

                                                    <div className="range-of-active">
                                                        <div className="active-avatar-iocn">
                                                            <img src={images.secondMail} alt="secondFemail" />
                                                        </div>
                                                        <div className="rang-in-per">
                                                            <p>0<span>%</span></p>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="list-of-avatar">
                                                    <h2>5th</h2>
                                                    <p>happy.fac...</p>

                                                    <div className="range-of-active">
                                                        <div className="active-avatar-iocn">
                                                            <img src={images.avatarJohn} alt="avatarJohn" />
                                                        </div>
                                                        <div className="rang-in-per">
                                                            <p>0<span>%</span></p>
                                                        </div>
                                                    </div>
                                                </div>



                                            </div>

                                        </div>

                                    </div>
                                }


                                {selectedTab === 2 &&

                                    <div>
                                        <div className="user-post">
                                            <div className="post-disp">
                                                <div className="user-pofile">
                                                    <img src={images.userProf} alt="userProf" />
                                                </div>
                                                <div className="user-name">
                                                    <h2>John_adam06</h2>
                                                    <p>1 hr ago</p>
                                                </div>
                                            </div>

                                            <div className="user-disp-text">
                                                <p>Sometimes we make the process more complicated than we need to. We will never make a journey of a thousand miles.</p>
                                            </div>

                                            <div className="post-image">
                                                <img src={images.post} alt="firstIcon" />
                                            </div>

                                            <div className=" comment-sec">
                                                <div>
                                                    {/* <img src={images.dotesReact} alt="userProf" /> */}
                                                </div>

                                                <div className="like-and-imozes">
                                                    <img src={images.commentIcon} alt="commentIcon" />
                                                    <img src={images.imozeIcon} alt="imozeIcon" />

                                                </div>

                                            </div>

                                        </div>

                                        <div className="user-post">
                                            <div className="post-disp">
                                                <div className="user-pofile">
                                                    <img src={images.userProf} alt="userProf" />
                                                </div>
                                                <div className="user-name">
                                                    <h2>John_adam06</h2>
                                                    <p>1 hr ago</p>
                                                </div>
                                            </div>

                                            <div className="user-disp-text">
                                                <p>Sometimes we make the process more complicated than we need to. We will never make a journey of a thousand miles.</p>
                                            </div>

                                            <div className="post-image">
                                                <img src={images.post} alt="firstIcon" />
                                            </div>

                                            <div className=" comment-sec">
                                                <div>
                                                    {/* <img src={images.dotesReact} alt="userProf" /> */}
                                                </div>

                                                <div className="like-and-imozes">
                                                    <img src={images.commentIcon} alt="commentIcon" />
                                                    <img src={images.imozeIcon} alt="imozeIcon" />

                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                }


                            </div>

                            <div className="right-inner-cricle">
                                <div className="inner-top-heading-section">
                                    <div className="active-members-heading avatar-adds">
                                        <h1>My Inner Circle</h1>
                                        {/* <img src={images.dotesReact} alt="questions" /> */}
                                    </div>

                                    <div className="reation">
                                        <div className="add-more-avatars     ">
                                            <span><img src={images.firstIcon} alt="firstIcon" /></span>
                                            <span><img src={images.avatarTow} alt="avatarTow" /></span>
                                            <span><img src={images.avatarThree} alt="avatarThree" /></span>
                                            <span><img src={images.avatarFour} alt="avatarfour" /></span>
                                            <span><img src={images.avatarFive} alt="avatarfour" /></span>
                                            <span><img src={images.firstIcon} alt="firstIcon" /></span>
                                            <span><img src={images.avatarTow} alt="avatarTow" /></span>
                                            <span><img src={images.avatarThree} alt="avatarThree" /></span>
                                            <span><img src={images.avatarFour} alt="avatarfour" /></span>
                                            <span><img src={images.avatarFive} alt="avatarfour" /></span>
                                            <span><img src={images.firstIcon} alt="firstIcon" /></span>
                                            <span><img src={images.avatarTow} alt="avatarTow" /></span>
                                            <span><img src={images.avatarThree} alt="avatarThree" /></span>
                                            <span><img src={images.avatarFour} alt="avatarfour" /></span>
                                            <span><img src={images.avatarFive} alt="avatarfour" /></span>
                                            <span><img src={images.firstIcon} alt="firstIcon" /></span>
                                            <span><img src={images.avatarTow} alt="avatarTow" /></span>
                                            <span><img src={images.avatarThree} alt="avatarThree" /></span>
                                            <span><img src={images.avatarFour} alt="avatarfour" /></span>
                                            <span><img src={images.avatarFive} alt="avatarfour" /></span>
                                            <span className="addmore-icons"><img src={images.addMore} alt="addmore" /></span>

                                        </div>
                                    </div>

                                    <div className="avatar-disp-text">
                                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>

                                    </div>

                                    <div className="activity-btn max-width">
                                        <button><span><img src={images.addMoreWhite} alt="addmore" /></span>Create Activity</button>
                                    </div>

                                </div>

                            </div>
                        </div>

                    </div>



                </div>
            </div>

        )
    }
export default InnerCircleReport

